// @ts-check
import fontSizes from '../fontSizes';
// The variants are actually imported by the theme, but colocating helps finding them more easily.

/** @type {Record<string, import('@react-pdf/types').Style>} */
const textVariants = {
  large: {
    // variant: 'text.default',
    fontWeight: 'light',
    fontSize: fontSizes.large,
    lineHeight: 'large',
    letterSpacing: 'large',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  semiTitle: {
    // variant: 'text.default',
    fontWeight: 'semibold',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  default: {
    fontFamily: 'Open Sans',
    fontWeight: 400,
    fontSize: fontSizes.body,
    // lineHeight: 'body',
    // letterSpacing: 'body',
  },

  small: {
    // variant: 'text.default',
    fontSize: fontSizes.small,
    lineHeight: 'small',
    letterSpacing: 'small',
  },

  smallest: {
    // variant: 'text.default',
    fontSize: fontSizes.smallest,
    lineHeight: 'smallest',
    letterSpacing: 'smallest',
  },
};

export default textVariants;

/**
 * @typedef {keyof textVariants} TextVariants
 */
